import * as React from 'react';
import data from '../../../../package.json';

const Logo = () => <img alt={'Logo'} src={process.env.PUBLIC_URL + 'logo.svg'} title={`v${data.version}`}/>;

export default Logo;